var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logout") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ui-kit-Desktop",
    transform: "translate(-1510.000000, -7181.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logout",
    transform: "translate(1510.000000, 7181.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#00458A",
    strokeWidth: 1.25824176,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(5.562076, 9.569575) rotate(-135.000000) translate(-5.562076, -9.569575) ",
    points: "2.56207599 6.56957503 8.56207599 6.56957503 8.56207599 12.569575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9119718,2.60387324 L14.3954883,2.60387324 C15.7853038,2.60387324 16.9119718,3.73054129 16.9119718,5.12035676 L16.9119718,14.0873897 C16.9119718,15.4772052 15.7853038,16.6038732 14.3954883,16.6038732 L10.9119718,16.6038732 L10.9119718,16.6038732",
    id: "Path",
    stroke: "#00458A",
    strokeWidth: 1.25824176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.06207599,
    y1: 9.57622605,
    x2: 11.062076,
    y2: 9.57622605,
    id: "Line-2",
    stroke: "#00458A",
    strokeWidth: 1.25824176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.9836a6f5ca429a4b8089bf32bfb68cde.svg";
export { ForwardRef as ReactComponent };